import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RecursivePartial } from '@models/apollo';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BookDuringPurchaseEnum, CartItem, ShoppingCart } from '@queries/generated';
import { safeReplay } from '@rx/safe-replay';
import { BehaviorSubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'vnm-checkout-booking',
  templateUrl: './checkout-booking.component.html',
  styleUrls: ['./checkout-booking.component.scss']
})
export class CheckoutBookingComponent {
  @Output() canDeactivate = new EventEmitter<boolean>();
  @Input() set shoppingCart(value: ShoppingCart) {
    this.shoppingCart$.next(value);
  }

  shoppingCart$ = new BehaviorSubject<ShoppingCart>(null);

  /// Get only the items that are bookable classes, enforced or optional.
  /// If there's any enforced with no booking, we can't proceed.
  items$ = this.shoppingCart$.pipe(
    map((shoppingCart) =>
      shoppingCart.cartItems.filter(
        (item) =>
          item.quantity == 1 &&
          item.product?.isInstructorLed &&
          item.product?.bookDuringPurchase !== BookDuringPurchaseEnum.Disallowed
      )
    ),
    tap((items) => this.handleCanDeactivate(items)),
    safeReplay()
  );

  ngOnInit() {
    this.items$.pipe(untilDestroyed(this)).subscribe((items) => this.handleCanDeactivate(items));
  }

  private handleCanDeactivate(items: RecursivePartial<CartItem[]>) {
    const pending = items.filter(
      (item) =>
        item.product?.bookDuringPurchase === BookDuringPurchaseEnum.Enforced &&
        !item.pendingIlBookingReservations.length
    );

    if (pending.length) {
      this.canDeactivate.emit(false);
    } else {
      this.canDeactivate.emit(true);
    }
  }
}
